module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAMAAAAoLQ9TAAAAAXNSR0IArs4c6QAAAD9QTFRFzMzM1NTU5OTk4+Pj4+Pj4+Pj4uLi4uLi4+Pj5OTk4+Pj4+Pj4+Pj4+Pj4+Pj4+Pj6urq6+vr+/v7/Pz8////flr00QAAAA90Uk5TBQaEiImLjo+R6Ozt7vDyQtUNKgAAAEBJREFUGNNjYGDm5IcDTiYGBlYBIRE4EBJgZ+BC4ouICPMy8IugAP7BK8CN6nQ+BjYBYSS+IAsDIxs3wvs8HIwAkTESElS1yMIAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/check-a.png
// module id = O6ph
// module chunks = 1